import { capitalize, last } from 'lodash';
import { BlackText, GrayText, GreenText, RedText } from '@/components/DesignLibrary/Widget/UserWorkflowActivity/Events/ColoredText';
import * as ApiModels from '@/typings/api-models';

const getHumanReadableAction = (action: string | null, details: unknown, type: ApiModels.ACTIVITY_TYPES): string => {
  if (!action) {
    return 'N/A';
  }

  if (
    type === ApiModels.ACTIVITY_TYPES.PAYMENT
    && details
    && typeof details === 'object'
    && 'amount' in details
    && details.amount
  ) {
    if (action === 'succeeded') {
      return `$${details.amount} paid`;
    }
    return `$${details.amount} ${action}`;
  }

  return action
    .split('-')
    .map(word => capitalize(word))
    .join(' ');
};

const getHumanReadableActionFromRollUp = (rollup: string): string => capitalize(last(rollup.split('-')));

type Props = {
  item: Pick<ApiModels.UserWorkflowActivity, 'type' | 'action' | 'activityType'>;
  details: unknown;
};

const ActionColumn: React.FC<Props> = ({ item, details }) => {
  const {action} = item;
  const rollup = item.activityType;
  const {type} = item;

  const actionText = type ? getHumanReadableAction(action, details, type) : getHumanReadableActionFromRollUp(rollup);

  if (type) {
    if (type === ApiModels.ACTIVITY_TYPES.MESSAGE) {
      return <GrayText>{actionText}</GrayText>;
    }
    if (action === 'succeeded') {
      return <GreenText>{actionText}</GreenText>;
    }
    if (action === 'failed') {
      return <RedText>{actionText}</RedText>;
    }
  } else {
    if (rollup === ApiModels.ACTIVITY_TYPES_AND_ACTIONS_ROLLUP.COMMENT_LEFT) {
      return <GrayText>{actionText}</GrayText>;
    }
    if (rollup === ApiModels.ACTIVITY_TYPES_AND_ACTIONS_ROLLUP.PAYMENT_SUCCEEDED) {
      return <GreenText>{actionText}</GreenText>;
    }
    if (rollup === ApiModels.ACTIVITY_TYPES_AND_ACTIONS_ROLLUP.PAYMENT_FAILED) {
      return <RedText>{actionText}</RedText>;
    }
  }

  return <BlackText>{actionText}</BlackText>;

};

const Wrapped: React.FC<Props> = (props) => (
  <p className="caption">
    <ActionColumn {...props} />
  </p>
);

export default Wrapped;